import api from '../api';
import { tokenService } from '../auth/tokenService';
import websocketService from '../websocketService';

export const authService = {
  login: async (credentials) => {
    const formData = new FormData();
    Object.keys(credentials).forEach(key => {
      formData.append(key, credentials[key]);
    });
    
    try {
      const response = await api.post('/auth/login', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      console.log(response);
      console.log(response.data);
      
      if (response.data.access_token) {
        tokenService.setTokens(response.data);
      }
      
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getDataUser: async () => {
    try {
      const response = await api.get('users/me-full');
      return response;
    } catch (error) {
      throw error;
    }
  },

  register: async (userData) => {
    const formData = new FormData();
    Object.keys(userData).forEach(key => {
      formData.append(key, userData[key]);
    });
    
    try {
      const response = await api.post('/auth/register', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  refreshToken: async () => {
    const refresh_token = tokenService.getRefreshToken();
    if (!refresh_token) {
      throw new Error('No refresh token available');
    }

    try {
      const response = await api.post('/auth/refresh', { refresh_token });
      if (response.data.access_token) {
        tokenService.setTokens(response.data);
      }
      return response;
    } catch (error) {
      tokenService.clearTokens(); // Limpiar tokens si hay error al refrescar
      throw error;
    }
  },

  logout: () => {
    // Disconnect WebSocket before clearing tokens
    websocketService.disconnect();
    tokenService.clearTokens();
  },

  forgotPassword: async (data) => {
    try {
      const response = await api.post('/auth/forgot-password', data);
      return response;
    } catch (error) {
      throw error;
    }
  },

  verifyCode: async (data) => {
    try {
      const response = await api.post('/auth/verify-code', data);
      return response;
    } catch (error) {
      throw error;
    }
  },

  resetPassword: async (data) => {
    try {
      const response = await api.post('/auth/reset-password', data);
      return response;
    } catch (error) {
      throw error;
    }
  },
};